module.exports = function getResource(label, vars = []) {
    const resources = {
        saveYourBeauryPrefs: 'Would you like to save this as your current Color IQ shade in your Beauty Preferences?',
        joinToSave: 'Inscrivez-vous au programme Beauty Insider pour économiser',
        signInToSave: 'Ouvrir une session pour enregistrer',
        save: 'Enregistrer',
        tooltipModalTitle: 'Préférences beauté',
        tooltipModalMessage: 'You can save your Beauty Preferences — such as Color IQ and hair concerns — to your account for a personalized shopping experience.',
        infoModalButton: 'Compris',
        savedPrefsModalTitle: 'Préférences beauté enregistrées',
        savedPrefsModalMessage: 'Vos préférences ont été enregistrées.',
        savedPrefsModalCancelButton: 'Modifier les préférences beauté',
        errorSavingModalTitle: 'Erreur',
        errorSavingModalMessage: 'Une erreur est survenue et nous n’avons pas pu traiter votre demande. Veuillez réessayer plus tard.',
        errorSavingModalButton: 'OK'
    };

    return resources[label];
};
